<script>
export default {
    components: {},
};
</script>

<template>
    <div>
        <div class="home-btn d-none d-sm-block">
            <a class="text-dark" href="#">
                <a href="/"><i class="mdi mdi-home-variant h2"></i></a>
            </a>
        </div>
        <div class="account-pages my-5 pt-5">
            <div class="container" style="animation: fadein 1s;">
                <slot/>
            </div>
        </div>
    </div>
</template>

<style>
    @keyframes fadein {
        from { opacity: 0; }
        to   { opacity: 1; }
    }
</style>
